module.exports = __webpack_public_path__ + "static/media/cover_template_default.837268c3.jpg";